"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CrashIcon;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
function CrashIcon(props) {
  const output = /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    y1: 512,
    y2: 0
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: 0,
    stopColor: "#ffe59a"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: 1,
    stopColor: "#ffffd5"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    y1: 398,
    y2: 114
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: 0,
    stopColor: "#ffde00"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: 1,
    stopColor: "#fd5900"
  })), /*#__PURE__*/_react.default.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "url(#a)",
    r: 256
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M184.941 344.75h142.118c6.806 0 11.079-7.375 7.72-13.287l-71.042-124.215c-1.596-2.773-4.563-4.498-7.737-4.498s-6.141 1.725-7.737 4.498l-71.042 124.233c-3.346 5.812.859 13.269 7.72 13.269zm62.177-97.625c0-4.906 3.973-8.875 8.882-8.875s8.882 3.969 8.882 8.875v35.5c0 4.905-3.973 8.875-8.882 8.875s-8.882-3.97-8.882-8.875zM256 309.25c4.905 0 8.882 3.973 8.882 8.875 0 4.901-3.977 8.875-8.882 8.875s-8.882-3.974-8.882-8.875c0-4.902 3.977-8.875 8.882-8.875zM398.118 114H206.384l35.529 35.5H407v-26.625a8.873 8.873 0 0 0-8.882-8.875zm-166.163 50.65L181.263 114h-67.381a8.873 8.873 0 0 0-8.882 8.875v266.25c0 4.905 3.973 8.875 8.882 8.875h284.235c4.91 0 8.882-3.97 8.882-8.875V167.25H238.235a8.881 8.881 0 0 1-6.28-2.6zm-91.426-6.275a8.873 8.873 0 0 1 8.882-8.875h35.53c4.91 0 8.882 3.969 8.882 8.875s-3.973 8.875-8.882 8.875h-35.53a8.873 8.873 0 0 1-8.882-8.875zm138.614 40.033c0 .009 0 .009.018.018l71.059 124.25c10.068 17.681-2.72 39.825-23.16 39.825H184.941c-20.489 0-33.216-22.224-23.16-39.808l71.059-124.267C237.611 190.14 246.476 185 256 185s18.389 5.14 23.143 13.408z",
    fill: "url(#b)"
  }));
  return output;
}
